var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category--dropdown"
  }, [_c('div', {
    staticClass: "select-holder"
  }, [_c('select', {
    on: {
      "change": function($event) {
        _vm.changeValue($event.target.value)
      }
    }
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item['id'],
        "selected": item['selected'],
        "innerHTML": _vm._s(item['name'])
      }
    })
  })), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "15px",
      "height": "10px",
      "viewBox": "0 0 15 10",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Arkiv-aktuelt",
      "transform": "translate(-704.000000, -283.000000)",
      "fill": "#343638"
    }
  }, [_c('g', {
    attrs: {
      "id": "Filter-employee",
      "transform": "translate(540.000000, 260.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Icon:-Arrow",
      "transform": "translate(171.500000, 27.705882) rotate(270.000000) translate(-171.500000, -27.705882) translate(166.500000, 20.205882)"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Shape",
      "points": "9.16523618 2.078075 7.51817735 0.431016176 0.459353824 7.48983971 7.51817735 14.5486632 9.16523618 12.9016044 3.75347147 7.48983971"
    }
  })])])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f1ce0f9","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue/components/categoryList.vue
// module id = 211
// module chunks = 0